// extracted by css-extract-rspack-plugin
export default {"root":"root-LFRZE1","signatureDateLabel":"signatureDateLabel-yJk5eQ text-headline-sm"};